export default "__VITE_ASSET__wMRssGMH__"